export default __webpack_public_path__ + "static/media/main_background_visual.7981727a.jpg";